import {InputValidator} from "../input-validate/inputValidation.js";

function validHandler($input) {
    const errorJson = InputValidator.getInputErrorJson($input);
    const isError = Object.values(errorJson).length > 0;
    if (!isError) {
        unActiveErrorModeAboutInput($input);
        return true;
    }
    validErrorHandler(errorJson);
    return false;
}

function isErrorAboutInput($input) {
    if ($($input).length === 0) {
        Mutil.mlog("입력 태그가 존재하지 않아 에러 처리를 할 수 없습니다.");
        return false;
    }
    const $interactiveWrap = $($input).parent();
    return $interactiveWrap.hasClass("status-error");
}

function activeErrorModeAboutInput($input, errorMsg = "") {
    const noExistAboutEmailInput = $($input).length === 0;
    if (noExistAboutEmailInput || Mutil.empty(errorMsg)) {
        return;
    }
    const $interactiveWrap = $($input).parent();
    if(!isErrorAboutInput($input)) {
        $interactiveWrap.addClass("status-error");
    }
    const $errorMsgSpan = $interactiveWrap.parent().find(".js-error-txt");
    $errorMsgSpan.text(`${errorMsg}`);
}
function activeErrorModeAboutInputTempLayer($inputTempLayer, errorMsg = "") {
    const noExistAboutEmailInput = $inputTempLayer.length === 0;
    if (noExistAboutEmailInput || Mutil.empty(errorMsg)) {
        return;
    }
    const $interactiveWrap = $inputTempLayer.find(".js-interactive-form-wrap");
    if($interactiveWrap.length === 0) {
        return;
    }

    if(!$interactiveWrap.hasClass("status-error")) {
        $interactiveWrap.addClass("status-error");
    }
    const $inputLayer = $inputTempLayer.parent();
    const $errorMsgSpan = $inputLayer.find(".js-error-txt");
    const $errorMsgLayer = $errorMsgSpan.parent();
    $errorMsgLayer.css("display", "block");
    $errorMsgSpan.css({
        "font-weight" : "400",
        "font-size" : "13px",
        "line-height" : "19px",
        "color" : "#FF6B6B",
    })
    $errorMsgSpan.text(`${errorMsg}`);
}


function unActiveErrorModeAboutInput($input) {
    const noExistAboutEmailInput = $($input).length === 0;
    if (noExistAboutEmailInput || !isErrorAboutInput($input)) {
        return;
    }
    const $interactiveWrap = $($input).parent();
    $interactiveWrap.removeClass("status-error");
    const $errorMsgSpan = $interactiveWrap.parent().find(".js-error-txt");
    $errorMsgSpan.empty();
}

function unActiveErrorModeAboutInputTempLayer($inputTempLayer) {
    const noExistAboutEmailInput = $inputTempLayer.length === 0;
    if (noExistAboutEmailInput) {
        return;
    }

    const $interactiveWrap = $inputTempLayer.find(".js-interactive-form-wrap");
    if($interactiveWrap.length === 0) {
        return;
    }

    $interactiveWrap.removeClass("status-error");
    const $inputLayer = $inputTempLayer.parent();
    const $errorMsgSpan = $inputLayer.find(".js-error-txt");
    const $errorMsgLayer = $errorMsgSpan.parent();
    $errorMsgLayer.css("display", "none");
    $errorMsgSpan.empty();
}
function validErrorHandler(errorJson) {
    const isError = Object.values(errorJson).length > 0;
    if (!isError) {
        return;
    }

    const $input = $(errorJson.errorObj);
    if ($input.length === 0) {
        return;
    }

    activeErrorModeAboutInput($input, errorJson.errorMessage);
}
function removeBlank($input) {
    if($($input).length === 0) {
        Mutil.mlog(" 입력 태그가 존재하지 않아 빈 문자열을 제거할 수 없습니다.");
        return ;
    }
    const inputVal = $input.val().replace(/ /gi, '');
    $input.val(inputVal);
}

function changeUpperCase2Lowercase($emailInput) {
    if ($emailInput.length === 0) {
        Mutil.mlog("이메일 입력 태그가 존재하지 않아 소문자로 바꿀 수 없습니다..");
        return;
    }
    $emailInput.val($emailInput.val().toLowerCase());
}
export const InputErrorHandler = {
    validHandler
    , unActiveErrorModeAboutInput
    ,activeErrorModeAboutInput
    , removeBlank
    , changeUpperCase2Lowercase
    ,unActiveErrorModeAboutInputTempLayer
    , activeErrorModeAboutInputTempLayer
}